<div class="modal-header">
    <span class="modal-header-title"> {{ 'FILES.DOUNLOAD_FILE_W_PEODUCT_DATA' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-6">
                <div class="form-group">
                    <label class="filter-label" for="attribute_id_field"> {{ 'MAPPING.MAPPING_GROUP' | translate }}</label>
                    <ng-select id="attribute_id_field"
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}" 
                        bindLabel="name" bindValue="id"
                        formControlName="mapping_id" 
                        [multiple]="false" 
                        [closeOnSelect]="true"
                        [items]="mappingSets" 
                        appendTo="body">
                        <ng-template ng-option-tmp let-item="item">
                            <div title="{{item.name}}">{{item.name}}</div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>   

            <div class="col-6">
                <div class="form-group">
                    <label class="filter-label" for="attribute_id_field"> Выберите язык</label>
                    <ng-select id="attribute_id_field"
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}" 
                        bindLabel="name" bindValue="id"
                        formControlName="lang" 
                        [multiple]="false" 
                        [closeOnSelect]="true"
                        [items]="lang" 
                        appendTo="body">
                    </ng-select>
                </div>
            </div>   

            <div class="onload-btn-block">
                
                <div class="col-9" *ngIf="file">
                    <table class="file-table">
                        <tbody>
                            <tr class="file-table-row">
                                <td class="file-table-cell">{{file.name}}</td>
                                <td class="file-table-cell">
                                    <button class="btn btn-light" type="button" (click)="deleteFile()">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-3 select-btn">
                    <a *ngIf="form.get('lang').value && !file" type="button" class="btn btn-light btn-sm" placement="top" ngbTooltip="{{ 'IMPORT_AND_EXPORT.DOUNLOAD_TEMPLATES' | translate }}" (click)="downloadFile()">
                        <i class="bi bi-exclamation-triangle-fill"></i>
                    </a>
                    <!-- <a type="button" class="btn btn-light btn-sm" placement="top" ngbTooltip="Скачать шаблон" href="/assets/templates/product/template_with_wsc_product_data_from_gdc.csv" download="template_with_wsc_product_data_from_gdc.csv">
                        <i class="bi bi-exclamation-triangle-fill"></i>
                    </a> -->
                    <button *ngIf="form.get('lang').value && !file" type="button" class="btn btn-primary btn-sm" (click)="fileInputUploadObject.click()" >
                        <input #fileInputUploadObject type="file" class="hide" (change)="onSelectedFiles($event.target.files)">
                        <span> {{ 'FILES.SELECTED_FILE' | translate }}</span>
                    </button>

                    <button *ngIf="file" type="button" class="btn btn-primary btn-sm" (click)="uploadFile()" [disabled]="fileUploadObject.inProgress">
                        <span *ngIf="!fileUploadObject.inProgress"> {{ 'UPLOAD_FILE' | translate }}</span>
                        <span *ngIf="fileUploadObject.inProgress">{{ 'DIALOG.LOADING' | translate }}...</span>
                    </button>

                </div>
                    
            </div>

            

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <!-- <button type="button" class="btn btn-primary btn-sm" (click)="onSend()">{{ 'SAVE'| translate}}</button> -->
    <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
</div>